import styles from './reviewCard.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Icon from '@/components/UI/icon/Icon';
import Avatar from '@/components/UI/avatar/Avatar';
import { HostReplyType } from '@/components/houses/_types/productItem.types';
import Badges from '@/components/UI/badges/Badges';
interface ReviewCardType {
  image: string;
  name: string;
  suggestStatus: string;
  date: string;
  rate: number;
  reviewContent: string;
  reply: HostReplyType;
  handleOpen?: () => void;
  showMore?: boolean;
  advantages?: string[];
  disadvantages?: string[];
  isBrief?: boolean;
}
const suggestObject = {
  like: {
    startIcon: 'like-2-Filled',
    type: 'success',
    label: 'پیشنهاد می‌کنم'
  },
  dislike: {
    startIcon: 'dislike-Filled',
    type: 'error',
    label: 'پیشنهاد نمی‌کنم'
  }
};
const ReviewCard = ({
  image,
  name,
  suggestStatus,
  date,
  rate,
  reviewContent,
  handleOpen,
  reply,
  advantages,
  disadvantages,
  isBrief = false
}: ReviewCardType) => {
  return <Box component={'article'} className={styles['review-card']} onClick={handleOpen} data-sentry-element="Box" data-sentry-component="ReviewCard" data-sentry-source-file="ReviewCard.tsx">
      <Box className={styles['user-information-wrapper']} data-sentry-element="Box" data-sentry-source-file="ReviewCard.tsx">
        <Box component={'header'} className={styles['user-information-wrapper']} data-sentry-element="Box" data-sentry-source-file="ReviewCard.tsx">
          <Avatar alt={name?.trim() || 'مهمان'} size={36} variant={'rounded'} src={image} data-sentry-element="Avatar" data-sentry-source-file="ReviewCard.tsx" />
          <Box className={styles['user-review-info']} data-sentry-element="Box" data-sentry-source-file="ReviewCard.tsx">
            <Typography component="span" variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="ReviewCard.tsx">
              {name?.trim() || 'مهمان'}
            </Typography>
            <Typography component="span" variant="bodyS" color={'neutral_500'} data-sentry-element="Typography" data-sentry-source-file="ReviewCard.tsx">
              {date}
            </Typography>
          </Box>
        </Box>
        <Box className={styles['rate-box']} component={'footer'} data-sentry-element="Box" data-sentry-source-file="ReviewCard.tsx">
          <Box className={styles['rate-number']} data-sentry-element="Box" data-sentry-source-file="ReviewCard.tsx">
            <Icon name={'star-filled'} type={'warning'} size={'xSmall'} data-sentry-element="Icon" data-sentry-source-file="ReviewCard.tsx" />
            <Typography variant={'bodyM'} color={'secondary_main'} data-sentry-element="Typography" data-sentry-source-file="ReviewCard.tsx">
              {rate}
            </Typography>
          </Box>
          {suggestStatus && suggestStatus !== 'no-idea' && <Badges {...suggestObject[suggestStatus]} />}
        </Box>
      </Box>
      {(advantages && advantages?.length > 0 || disadvantages && disadvantages?.length > 0) && <Box className={styles['positive-negative-container']}>
          {advantages?.map((item, index) => <Box className={styles['positive-negative-items']} key={'REVIEW_ADVANTAGES_INDEX_' + index}>
              <Icon name="add" type="success" size={16} />
              <Typography component="span" variant="bodyS">
                {item}
              </Typography>
            </Box>)}
          {disadvantages?.map((item, index) => <Box className={styles['positive-negative-items']} key={'REVIEW_DISADVANTAGES_INDEX_' + index}>
              <Icon name="minus" type="error" size={16} />
              <Typography component="span" variant="bodyS">
                {item}
              </Typography>
            </Box>)}
        </Box>}
      {reviewContent && <Typography variant="bodyM" component={'p'} color={'secondary_main'} className={isBrief ? styles['brief'] : styles['review-content']}>
          {reviewContent}
        </Typography>}
      {reply && <Box component={'article'} className={styles['host-reply-container']}>
          <Box component={'header'} className={styles['user-information-wrapper']}>
            <Avatar alt={reply?.host_name?.trim() || 'میزبان'} size={36} variant={'rounded'} src={reply?.host_avatar_path} />
            <Box className={styles['user-review-info']}>
              <Typography component="span" variant="bodyM">
                {reply?.host_name?.trim() || 'میزبان'}
              </Typography>
              <Typography component="span" variant="bodyS" color={'neutral_500'}>
                پاسخ میزبان
              </Typography>
            </Box>
          </Box>
          <Typography variant="bodyM" component={'p'} color={'secondary_main'} className={isBrief ? styles['brief'] : styles['review-content']}>
            {reply.comment}
          </Typography>
        </Box>}
    </Box>;
};
export default ReviewCard;